import CategoriesPromoGrid from './CategoriesPromoGrid'

export default CategoriesPromoGrid
